var _ = require('underscore/underscore.js');
var Base = require('front/components/Base/Base');

var template = require('./ProductionDesignInitiativeApplicationUpload.jinja');
require('./ProductionDesignInitiativeApplicationUpload.less');


module.exports = Base.extend({

    template: template,

    events: {
        'change input': 'changeFile'
    },


    tempFilesApi: function () {
        return (Urls['front:api:files:temp-file-upload']());
    },


    initialize: function (options) {
        this.options = options || {};

        _.bindAll(this, 'tempFilesApi');

         //extract filename from full path
        var filename = this.$el.attr('data-file');

        if (filename) {
            filename = filename.split('/');
            this.$('.ProductionDesignInitiativeApplicationUpload-filename a').text(filename[filename.length - 1]);
        }


        Base.prototype.initialize.call(this, options);
    },


    deactivate: function (params) {
        this.resetFileLoading();

        return Base.prototype.deactivate.call(this, params);
    },


    getData: function () {
        var fileFileData = this.$el.attr('data-file');

        return {
            'file': fileFileData ? (this.$el.attr('data-new') ? JSON.parse(fileFileData) : fileFileData) : null
        };
    },


    changeFile: function (e) {
        if (!e.target.files || !e.target.files.length) return;

        this.resetFileLoading();

        var fil = e.target.files[0];
        var self = this;

        this.$el.attr('data-state', 'loading');
        this.$('.ProductionDesignInitiativeApplicationUpload-filename a').text(fil.name);

        this.$('.ProductionDesignInitiativeApplicationUpload-filename span')
            .html('File Uploading:&nbsp;')
            .removeClass('error');

        this.fileLoadXhr = new XMLHttpRequest();
        this.fileLoadXhr.open('POST', this.tempFilesApi());

        this.fileLoadXhr.onload = function (res, data) {
            var responseObject = app.AdoptTempFileObject(this.responseText, 'file');

            self.$el.attr('data-file', JSON.stringify(responseObject));
            self.$el.attr('data-new', 1);
            self.$el.attr('data-state', 'idle');
            self.$('.ProductionDesignInitiativeApplicationUpload-filename span').html('File Uploaded:&nbsp;');
        };

        this.fileLoadXhr.onerror = function () {
            self.$el.attr('data-file', '');
            self.$el.attr('data-state', 'idle');
            self.$('.ProductionDesignInitiativeApplicationUpload-filename span')
                .html('File Upload Error!')
                .addClass('error');
            self.$('.ProductionDesignInitiativeApplicationUpload-filename a').text('');
        };


        var formData = new FormData();
        formData.append('file', fil);
        this.fileLoadXhr.send(formData);

        $(e.currentTarget).val('');
    },


    resetFileLoading: function () {
        this.fileLoadXhr && this.fileLoadXhr.abort();
    }
});


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/ProductionDesignInitiativeApplication/ProductionDesignInitiativeApplicationUpload.js
// module id = 233
// module chunks = 0